import React from "react"

export default React.createContext({
  tabSelected: "home",
  hideTabs: false,
  goToOrderProgress: null,
  setTabSelected: () => {},
  backToOrderProgress: () => {},
})
